<template>
  <v-dialog
    ref="dialogDate"
    v-model="modalDate"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="dateFormatted"
        :label="label"
        :rules="rules"
        append-icon="mdi-calendar"
        @click:append="modalDate = true"
        readonly
        v-bind="attrs"
        v-on="on"
        :hide-details="hideDetails"
        :clearable="clearable"
        outlined
        dense
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      scrollable
      locale="th-TH"
      :year-format="yearFormatted"
      :header-date-format="headerDateFormatted"
      :min="min"
      :max="max"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modalDate = false">ยกเลิก</v-btn>
      <v-btn text color="primary" @click="onSubmit">ตกลง</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    label: {
      type: String,
      default: 'Date'
    },
    value: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array
    }
  },
  computed: {
    date: {
      // getter
      get: function() {
        return this.value
      },
      // setter
      set: function(value) {
        this.$emit('input', value)
      }
    },
    dateFormatted() {
      return this.date ? moment(this.date).format('DD/MM/YYYY') : ''
    }
  },
  data() {
    return {
      modalDate: false
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dialogDate.save(this.date)
      this.$emit('submit')
    },
    yearFormatted(year) {
      return `ค.ศ. ${year}`
    },
    headerDateFormatted(date) {
      // use momentjs
      return moment(date)
        .locale('th')
        .format('MMMM YYYY')

      // not use library
      // const monthsOfYear = [
      //   'มกราคม',
      //   'กุมภาพันธ์',
      //   'มีนาคม',
      //   'เมษายน',
      //   'พฤษภาคม',
      //   'มิถุนายน',
      //   'กรกฎาคม',
      //   'สิงหาคม',
      //   'กันยายน',
      //   'ตุลาคม',
      //   'พฤศจิกายน',
      //   'ธันวาคม'
      // ]
      // let i = new Date(date).getMonth(date)
      // return `${monthsOfYear[i]} ${date.split('-')[0]}`
    }
  }
}
</script>
